__turbopack_context__.v({
  "container": "DonationImpactGlobalHealth-module-scss-module__mivZoG__container",
  "impact": "DonationImpactGlobalHealth-module-scss-module__mivZoG__impact",
  "smartdistributionlabel": "DonationImpactGlobalHealth-module-scss-module__mivZoG__smartdistributionlabel",
  "wrapper": "DonationImpactGlobalHealth-module-scss-module__mivZoG__wrapper",
});
